import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { popupSecondaryContentVisibilitySelector } from '../../../redux/ui/selectors';

const mapStateToProps = state => ({
  secondaryContentVisible: popupSecondaryContentVisibilitySelector(state),
});

export const enhance = compose(
  injectIntl,
  connect(mapStateToProps),
);



// WEBPACK FOOTER //
// ./src/components/common/SimpleFormPopup/enhance.js